import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { PiHandCoins } from "react-icons/pi";
import { MdOutlineChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function SummaryCards({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);
    const navigate = useNavigate();

    const currentMonthName = new Date().toLocaleString("default", {
        month: "short",
    });

    const currentExpenseData = [
        {
            amount: "₹" + (summaryData?.totalExpense || 0),
            subTitle: (summaryData?.todayExpense || '0'),
            label: "Total Expenses",
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-red-400" />,
            filter: 'All',
        },
        {
            amount: "₹" + (summaryData?.pendingExpenseAmount || 0),
            label: `Pending/Unpaid Exp`,
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-gray-400" />,
            filter: 'PENDING',
            link: '/finance/expenses/pending',
            urgent: Number(summaryData?.pendingExpenseAmount || 0) > 0,
        },
        // {
        //     amount: "₹" + summaryData?.todayExpense || 0,
        //     label: "Today's Expenses",
        //     color: "text-black",
        //     icon: <PiHandCoins size={20} className="text-gray-400" />,
        //     filter: 'TE',
        // },
        {
            amount: "₹" + (summaryData?.rentExpense || 0),
            //label: `${currentMonthName} Expenses`,
            label: `Rent Expenses`,
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-gray-400" />,
            filter: 'BRE',
        },

        {
            amount: "₹" + (summaryData?.staffSalaryExpense || 0),
            //label: `${currentMonthName} Rent & Utilities`,
            label: `Staff Salaries`,
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-red-400" />,
            filter: 'SSE',
        },
        {
            amount: "₹" + (summaryData?.vendorExpense || 0),
            //label: `${currentMonthName} Rent & Utilities`,
            label: `Vendor Expenses`,
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-red-400" />,
            filter: 'VE',
        },

        {
            amount: "₹" + (summaryData?.emiExpense || 0),
            label: `EMI`,
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-gray-400" />,
            filter: 'EMIE',
        },
        {
            amount: "₹" + (summaryData?.securityExpenseAmount || 0),
            label: `Deposit to Landlord/s`,
            color: "text-black",
            icon: <PiHandCoins size={20} className="text-gray-400" />,
            filter: 'SE',
        },
        // {
        //     amount: "₹" + summaryData?.curMonthSalaryExpenses || 0,
        //     label: `${currentMonthName} Salary & Wages`,
        //     color: "text-black",
        //     icon: <PiHandCoins size={20} className="text-orange-400" />,
        //     filter: 'CSE',
        // },
        // {
        //     amount: "₹" + summaryData?.curMonthFoodExpenses || 0,
        //     label: `${currentMonthName} Food/Kitchen`,
        //     color: "text-black",
        //     icon: <PiHandCoins size={20} className="text-orange-400" />,
        //     filter: 'CFE',
        // },
    ];
    return (
        <Wrapper>
            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {currentExpenseData.map((item, index) => (
                    <Card $selected={selectedId === index} index={index} key={index}
                        // onClick={() => {
                        //     setSelectedId(index);
                        //     onClick(item.filter);
                        // }
                        onClick={() => {
                            if (item.link) {
                                navigate(item.link);
                                return;
                            }
                            const isSelected = selectedId === index;

                            setSelectedId(isSelected ? null : index);
                            onClick(isSelected ? "All" : item.filter);
                        }}
                    >
                        <ValueRow>
                            <div className='flex flex-row'>
                                <Value color={item.color} $urgent={item.urgent}>{item.amount}</Value>
                                {item.subTitle &&
                                    <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(₹" + item.subTitle + ")"}</span>
                                }
                            </div>

                        </ValueRow>
                        <Label $urgent={item.urgent}>
                            {item.label}
                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[220px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedid, index }) => selectedid === index ? "shadow-sm shadow-primary-color" : ""}`;
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Card = tw.div`
  group
  min-w-[220px]
  rounded-lg
  p-4
  cursor-pointer
  border
  shadow-sm
  transition-all duration-200

  ${({ $urgent, $selected }) => {
        if ($urgent && $selected) {
            return "bg-orange-50 border-primary-color border-l-4 border-l-orange-500 shadow-md";
        }

        if ($urgent) {
            return "bg-orange-50 border-orange-200 border-l-4 border-l-orange-500 hover:bg-orange-100 hover:border-orange-300";
        }

        if ($selected) {
            return "bg-white border-primary-color shadow-md";
        }

        return "bg-white border-gray-100 hover:shadow-md hover:border-gray-200";
    }}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-xl font-semibold

  ${({ $urgent }) =>
        $urgent
            ? "text-orange-800"
            : "text-gray-900"
    }
`;

const Label = tw.div`
  flex
  mt-2
  text-sm
  items-center
  justify-between

  ${({ $urgent }) =>
        $urgent
            ? "text-orange-800 font-medium"
            : "text-gray-500"
    }
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;

